import Vue from 'vue'
import Vuex from 'vuex'
import rootModule from './rootModule'
import token from './modules/token'
import verification from './modules/verification'
import psap from './modules/psap'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: rootModule.state,
  actions: rootModule.actions,
  getters: rootModule.getters,
  mutations: rootModule.mutations,
  modules: {
    token,
    verification,
    psap
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js